export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'

export const GETUSER = 'GETUSER'

export const TOGGLE_SIDERBAR = 'TOGGLE_SIDERBAR'

export const SET_LOGIN_INFO = 'SET_LOGIN_INFO'

export const SET_breadcrumbs = 'set_breadcrumbs'

export const SET_TOKEN = 'SET_TOKEN'

export const CLEAR_TOKEN = 'CLEAR_TOKEN'

export const ADDRESS ='ADDRESS'

export const HOME_STATUS='HOME_STATUS'

export const RUTER_PARAMS="RUTER_PARAMS"

export const UPDATE_PARAMS='UPDATE_PARAMS'

export const RECORD_TREE='RECORD_TREE'

export const OUTER_TREE='OUTER_TREE'
export const OUTER_ELEMENT='OUTER_ELEMENT'

export const EDITCOLUMS='EDITCOLUMS'

export const EDITPRICESVO='EDITPRICESVO'

export const CATEMODITYATTRIBUTE='CATEMODITYATTRIBUTE'

export const DEALERMODITY='DEALERMODITY'


// WEBPACK FOOTER //
// ./src/store/types.js